import {useState} from 'react'
import ChangePasswordModal from 'shared/ui/ChangePasswordModal'
import Style from './style'

import MainHeader from 'widget/MainHeader'

import timestampCalculator from 'shared/lib/timestampCalculator'
import DTStyle from 'shared/style/detailTableStyle'

import useGetSubManagerDetail from 'entity/sub-manager/useGetSubManagerDetail'
import { convertRoleAsName } from 'shared/constant/lookup/role'

const SubAdminDetail = () => {
	const [isOpenChangePassword, setIsOpenChangePassword] = useState(false)
	const [subAdminData] = useGetSubManagerDetail()
	const storeManagerDataList = [
		{
			label: 'IDX',
			value: subAdminData?.data?.idx,
		},
		{
			label: '승인 상태',
			value: subAdminData?.data?.is_approve ? '승인' : '미승인',
		},
		{
			label: '이름',
			value: subAdminData?.data?.name,
		},
		{
			label: '관리자 연락처',
			value: subAdminData?.data?.contact,
		},
		{
			label: '아이디',
			value: subAdminData?.data?.id,
		},
		{
			label: '비밀번호',
			value: subAdminData?.data?.password || '-',
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(subAdminData?.data?.created_at),
		},
	]

	const brandDataList = [
		{
			label: '브랜드명',
			value: subAdminData?.data?.franchise_name || '-',
		},
		{
			label: '대표자명',
			value: subAdminData?.data?.franchise_address || '-',
		},
		{
			label: '대표 연락처',
			value: subAdminData?.data?.franchise_contact || '-',
		},
	]

	const btnList = [
		{
			label: '비밀번호 변경',
			clickEvent: () => setIsOpenChangePassword(true),
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader title={`관리자 정보 상세`} btnList={btnList} />

			<Style.AreaDiv>
				<h2>{convertRoleAsName[subAdminData?.data?.manager_role_flag] || '관리자'} 정보</h2>
				<DTStyle.TableDiv>
					{storeManagerDataList?.map((elem) => (
						<DTStyle.TableElement>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>

			<Style.AreaDiv>
				<h2>브랜드 정보</h2>
				<DTStyle.TableDiv>
					{brandDataList?.map((elem) => (
						<DTStyle.TableElement>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>
			{isOpenChangePassword && (
				<ChangePasswordModal
					closeEvent={() => setIsOpenChangePassword(false)}
					managerId={subAdminData?.data?.idx}
				/>
			)}
		</Style.Wrapper>
	)
}

export default SubAdminDetail
